<mat-accordion [ngStyle]="applyDesign()">

  <mat-expansion-panel hideToggle [expanded]="panelExpanded" disabled>
    <mat-expansion-panel-header style="height: 34px;">

      <mat-panel-title>

        <div class="question-title-section">

          <span class="title-style">{{ title }}</span>
          <span *ngIf="isFirstQuestionnaire" class="is-mandatory" [ngClass]="incommingDataArray.length > 0 ? 'mandatory-valid' : 'mandatory-invalid '"></span>

        </div>

      </mat-panel-title>

      <mat-panel-description>

        <button class="add-edit-button">

          <img *ngIf="isAddingOrEditing === 'adding'" src="assets/icons/add_button.svg" (click)="executeFunction()">
          <img *ngIf="isAddingOrEditing === 'editing'" src="assets/icons/edit_button.svg" (click)="executeFunction()">
        </button>

      </mat-panel-description>

      <button mat-icon-button (click)="panelExpanded = !panelExpanded">
        <mat-icon [class.rotate-icon]="panelExpanded">keyboard_arrow_down</mat-icon>
      </button>

    </mat-expansion-panel-header>

    <div class="table-style" [ngStyle]="applyTableDesign()">

      <table (input)="autoResize($event)">

        <tr *ngFor="let comorbity of showSelectedItemsOnly(incommingDataArray)" class="table-row-even">

          <td style="width: 50px;"> {{ comorbity.comorbityCid.answer[0] }} </td>

          <td style="width: 220px; text-overflow: ellipsis; white-space: nowrap; overflow: hidden;" [matTooltip]="comorbity.comorbityName.answer[0]" [matTooltipPosition]="'below'"> {{ comorbity.comorbityName.answer[0] }} </td>

          <td style="width: 120px;"> {{ comorbity.comorbityStatus.answer[0] }} </td>

          <td style="width: 220px; text-overflow: ellipsis; white-space: nowrap; overflow: hidden;" [matTooltip]="comorbity.medicationsName.answer[0]" [matTooltipPosition]="'below'"> {{ comorbity.medicationsName.answer[0] }} </td>

          <td style="width: 220px; text-overflow: ellipsis; white-space: nowrap; overflow: hidden;" [matTooltip]="comorbity.comorbityObservations.answer[0]" [matTooltipPosition]="'below'"> {{ comorbity.comorbityObservations.answer[0] }} </td>

        </tr>
      </table>

    </div>
  </mat-expansion-panel>

</mat-accordion>
